module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w5-file-component",
    attrs: {
      "name": _vm.name
    },
    on: {
      "click": _vm.clearErrors
    }
  }, [_vm._l((_vm.currentValue), function(item, indx) {
    return _c('div', {
      key: 'item-' + indx,
      staticClass: "w5-file-uploader-item",
      class: {
        'multiple-item': _vm.multiple
      }
    }, [_c('div', {
      staticClass: "w5-file-uploader-item-image-wrapper",
      on: {
        "click": function($event) {
          return _vm.previewImage(item)
        }
      }
    }, [(item.type && String(item.type).substr(0, 5).toLowerCase() === 'image') ? [(item.image.src) ? _c('img', {
      style: ('width:' + item.imgWidth + 'px;height:' + item.imgHeight + 'px;'),
      attrs: {
        "src": item.image.src
      }
    }) : _c('font-awesome-icon', {
      attrs: {
        "icon": "image"
      }
    })] : [_c('div', {
      staticClass: "attach-no-image-preview-file-uploader"
    }, [_vm._v(_vm._s(item.ext))])]], 2), _vm._v(" "), _c('div', {
      staticClass: "w5-file-uploader-item-title"
    }, [_vm._v(_vm._s(_vm._f("ftc")(item.title)))]), _vm._v(" "), _c('div', {
      staticClass: "w5-file-uploader-item-size"
    }, [(item.status === 'done' && item.size) ? _c('span', [_vm._v(_vm._s(_vm._f("bytes")(item.size)))]) : _vm._e(), _vm._v(" "), (item.status === 'loading' || item.status === 'uploading') ? _c('span', {
      staticClass: "font-size-85"
    }, [_c('img', {
      attrs: {
        "src": "/static/img/loading-hor16.gif"
      }
    }), _c('br'), _vm._v(_vm._s(item.progress ? item.progress : ''))]) : _vm._e()]), _vm._v(" "), (_vm.crud !== 'twofa') ? _c('div', {
      staticClass: "w5-file-uploader-item-buttons"
    }, [(item.status === 'done') ? _c('font-awesome-icon', {
      attrs: {
        "title": _vm._f("ftc")('main/delete'),
        "icon": "trash-alt"
      },
      on: {
        "click": function($event) {
          return _vm.deleteItem(item)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.status === 'loading' || item.status === 'uploading') ? _c('font-awesome-icon', {
      attrs: {
        "title": _vm._f("ftc")('main/cancel'),
        "icon": "times-circle"
      },
      on: {
        "click": function($event) {
          return _vm.cancelUploading(item)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.status === 'crop') ? _c('font-awesome-icon', {
      staticClass: "miganie-animation",
      attrs: {
        "title": "Обрезка",
        "icon": "cut"
      }
    }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.keyfile) ? _c('input', {
      attrs: {
        "type": "hidden"
      },
      domProps: {
        "value": item.keyfile
      }
    }) : _vm._e()])
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.buttonVisibility),
      expression: "buttonVisibility"
    }],
    staticClass: "w5-file-add-button"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "paperclip"
    }
  }), _c('div', {
    staticClass: "w5-file-add-button-caption"
  }, [_vm._v(_vm._s(_vm.buttonTitle))]), _vm._v(" "), (_vm.multiple) ? _c('input', {
    ref: "fileUploaderInput",
    attrs: {
      "type": "file",
      "name": "w5-file-uploader[]",
      "multiple": "multiple"
    },
    on: {
      "change": _vm.onSelect
    }
  }) : _c('input', {
    ref: "fileUploaderInput",
    attrs: {
      "type": "file",
      "name": "w5-file-uploader"
    },
    on: {
      "change": _vm.onSelect
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors !== ''),
      expression: "errors !== ''"
    }, {
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.errors)),
      expression: "localeFtc(errors)"
    }],
    staticClass: "alert alert-danger w5-alert-valid",
    attrs: {
      "role": "alert"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModal),
      expression: "showModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": function($event) {
        return _vm.closeDialog($event, false, true)
      }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    style: ('width:' + _vm.modalWidth + 'px;'),
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('img', {
    ref: "imageInDialog",
    style: ('width:' + _vm.imageWidth + 'px; height:' + _vm.imageHeight + 'px;')
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modalCrop),
      expression: "modalCrop"
    }],
    staticClass: "modal-footer",
    staticStyle: {
      "padding": "5px 5px 7px",
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "w5-image-preview-crop-wrapper"
  }, [_c('img', {
    ref: "previewCropSquare",
    staticClass: "w5-image-preview-crop"
  })]), _vm._v(" "), _c('div', {
    staticClass: "w5-image-preview-crop-wrapper round"
  }, [_c('img', {
    ref: "previewCropRound",
    staticClass: "w5-image-preview-crop"
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "btn btn-submit btn-submut-small",
    on: {
      "click": _vm.finishCrop
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('notes/file_type')))])])])])])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0c1ad0a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/file.vue
// module id = 354
// module chunks = 0